import styled from 'styled-components';

export const StyledDiscoverTeamSection = styled.div`
  width: 100%;
  .inputs-wrapper {
    @media (min-width: 992px) {
      display: flex;
      gap: 16px;
      max-width: 500px;
      margin-left: auto;
    }

    .select-wrapper {
      width: 100%;
      margin: 0 0 10px;

      @media (min-width: 992px) {
        max-width: 200px;
      }
    }
  }
  .cards-wrap {
    position: relative;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
    margin-bottom: 20px;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 992px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1400px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;
